import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image, type StaticImageData } from 'Components/Image';

import useResponsiveVariant from 'utils/useResponsiveVariant';

type ImageAndTextOverlayContentType = {
  imgAlt: string;
  imgMobile: StaticImageData;
  imgDesktop: StaticImageData;
  imgTablet?: StaticImageData;
};

type ImageAndTextOverlayProps = {
  imgData: ImageAndTextOverlayContentType;
  dataTestId?: string;
};
const BackgroundImage = styled(Image)`
  object-fit: cover;
`;

const TextContainer = styled.div`
  grid-area: image;
  z-index: 1;
`;

const Wrapper = styled.div`
  width: 100%;
  height: 260px;

  display: grid;
  grid-template-areas: 'image';

  overflow: hidden;
  border-radius: ${theme.radius.xs};

  ${legacyTheme.breakpoints.up('md')} {
    height: 430px;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;

  grid-area: image;
`;

export const ImageAndTextOverlay = ({
  imgData,
  children,
  dataTestId,
}: ImageAndTextOverlayProps & { children: React.ReactNode }) => {
  const { isMobile, isTablet, isDesktop } = useResponsiveVariant();
  const { imgAlt, imgMobile, imgDesktop } = imgData;

  return (
    <Wrapper data-testid={dataTestId}>
      <ImageContainer>
        {isDesktop && <BackgroundImage alt={imgAlt} fill src={imgDesktop.src} />}
        {isTablet && <BackgroundImage alt={imgAlt} fill src={imgMobile.src} />}
        {isMobile && <BackgroundImage alt={imgAlt} fill src={imgMobile.src} />}
      </ImageContainer>
      <TextContainer>{children}</TextContainer>
    </Wrapper>
  );
};
